<template>
    <tr class="email__list_table_item">
        <td class="email__list_table_item_category">{{ emailCategory }}</td>
        <td class="email__list_table_item_title">{{ emailTitle }}</td>
        <td class="email__list_table_item_trigger">{{ emailTrigger }}</td>
        <td class="email__list_table_item_subject">{{ emailSubject }}</td>
        <td class="email__list_table_item_recipient">{{ emailRecipients }}</td>
        <td class="email__list_table_item_status">
            <form-checkbox
                class="email__list_table_item_status_checkbox"
                :label="''"
                :switcher="true"
                :active-inactive="true"
                :name="`email_list_table_item_status_${index}`"
                :prevent="true"
                :value="emailStatus"
                @input="performEmit(`emit-update-status`, item)"
            ></form-checkbox>
        </td>
        <td class="email__list_table_item_view">
            <div class="columns">
                <div class="column is-narrow">
                    <component-button
                        :name="`email_list_table_item_category_${item.name}`"
                        :theme="'default'"
                        :size="'medium'"
                        :align="'left'"
                        @click="performEmit('emit-open-pop', { item: item, identifier: item.identifier, ownerId: item.ownerId })"
                    >Edit
                    </component-button>
                </div>
                <template v-if="buttonMenuList.length">
                    <div class="column is-narrow">
                        <component-button-menu
                            ref="buttonmenu"
                            :buttons="buttonMenuList"
                            :loading-on-open="true"
                            @emit-open="checkEmailUsage"
                            @emit-view-usage="redirectToCatalogItemsUsage"
                            @emit-delete="performEmit('emit-delete', { id: item.id, emailUsage })"
                        ></component-button-menu>
                    </div>
                </template>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import FormCheckbox from '@/components/default/forms/FormCheckbox'
import { fromArrayToStringComma, fromCamelCaseToString, toCapitalize } from '@/functions'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'

export default {
  name: 'EmailListTableItem',
  data () {
    return {
      emailUsage: []
    }
  },
  components: {
    ComponentButtonMenu,
    FormCheckbox,
    ComponentButton
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number
    }
  },
  computed: {
    buttonMenuList () {
      let listArr = []

      if (this.emailUsage.length) {
        listArr.push({
          key: 'view-usage',
          name: 'View usage'
        })
      }
      if (this.emailCloned) {
        listArr.push({
          key: 'delete',
          name: 'Delete'
        })
      }

      return listArr
    },
    emailId () {
      return this.item.id
    },
    emailCategory () {
      const category = this.item.category
      return category ? category.toUpperCase() : '-'
    },
    emailTitle () {
      const title = this.item.title
      return title || '-'
    },
    emailTrigger () {
      const triggerEvent = this.item.triggerEvent
      const triggerDescription = this.item.triggerDescription

      return triggerEvent ? toCapitalize(fromCamelCaseToString(triggerEvent)) : triggerDescription
    },
    emailRecipients () {
      let availableRecipients = this.item.availableRecipients
      if (availableRecipients) {
        availableRecipients = availableRecipients.map(item => {
          return toCapitalize(fromCamelCaseToString(item))
        })
      }
      return fromArrayToStringComma(availableRecipients) || '-'
    },
    emailSubject () {
      return this.item.subject
    },
    emailStatus () {
      return this.item.active
    },
    emailCloned () {
      return this.item.cloned
    },
    emailTriggerEvent () {
      return this.item.triggerEvent
    },
    emailOwnerId () {
      return this.item.ownerId
    }
  },
  methods: {
    checkEmailUsage () {
      this.emailUsage = []
      return this.$store.dispatch('checkEmailUsage', this.emailId).then(response => {
        if (response && response.length) {
          this.emailUsage = response.map(obj => obj.catalogItemId)
        }
      }).finally(() => {
        this.$refs.buttonmenu.stopLoading()
      })
    },
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    },
    redirectToCatalogItemsUsage () {
      const emailUsageIds = this.emailUsage.join(',')
      this.$router.push({ name: 'ebs-course-list', query: { view: 'admin', ids: emailUsageIds } })
    }
  }
}
</script>
